<template>
  <div class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-billing">
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.billing.myPayments.subject') === $route.params.subject
            && ($t('mEditionMenu.billing.myPayments.children.invoiceHistory.subedition') === $route.params.subedition ||
              $t('mEditionMenu.billing.myPayments.children.invoice.subedition') === $route.params.subedition)
            ? 'submenu-item-active submenu-item-active-billing'
            : '']"
          :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.myPayments.subject')}/${$t('mEditionMenu.billing.myPayments.children.invoiceHistory.subedition')}`"
        >
          {{ $t('mEditionMenu.billing.myPayments.children.invoiceHistory.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.billing.myPayments.subject') === $route.params.subject
            && ($t('mEditionMenu.billing.myPayments.children.billingData.subedition') === $route.params.subedition)
            ? 'submenu-item-active submenu-item-active-billing'
            : '']"
          :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.myPayments.subject')}/${$t('mEditionMenu.billing.myPayments.children.billingData.subedition')}`"
        >
          {{ $t('mEditionMenu.billing.myPayments.children.billingData.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.billing.myPayments.subject') === $route.params.subject
            && ($t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition') === $route.params.subedition ||
              $t('mEditionMenu.billing.myPayments.children.changePlan.subedition') === $route.params.subedition)
            ? 'submenu-item-active submenu-item-active-billing'
            : '']"
          :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.myPayments.subject')}/${$t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition')}`"
        >
          {{ $t('mEditionMenu.billing.myPayments.children.subscribedPlan.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.billing.myPayments.subject') === $route.params.subject
            && $t('mEditionMenu.billing.myPayments.children.paymentMethod.subedition') === $route.params.subedition
            ? 'submenu-item-active submenu-item-active-billing'
            : '']"
          :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.myPayments.subject')}/${$t('mEditionMenu.billing.myPayments.children.paymentMethod.subedition')}`"
        >
          {{ $t('mEditionMenu.billing.myPayments.children.paymentMethod.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.billing.myPayments.subject') === $route.params.subject
            && $t('mEditionMenu.billing.myPayments.children.cancelSubscription.subedition') === $route.params.subedition
            ? 'submenu-item-active submenu-item-active-danger'
            : 'submenu-item-danger']"
          :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.myPayments.subject')}/${$t('mEditionMenu.billing.myPayments.children.cancelSubscription.subedition')}`"
        >
          {{ $t('mEditionMenu.billing.myPayments.children.cancelSubscription.subText') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsSubMenu'
}
</script>
